// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"146":"481c0fef","1476":"efcc757f","4129":"15996470","8592":"609b3b1a"}[chunkId] + ".chunk.css";
};